import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';

import { Parameter } from '@classes/bizzdev/parameter/parameter';
import { ParameterCustom } from '@classes/bizzdev/parameter/parameter-custom';
import { ParametersResult } from '@classes/bizzdev/parameter/Parameters-result';

@Injectable({
	providedIn: 'root'
})
export class ParameterService {
	private baseUrl = environment.apiUrl + 'parameter';

	constructor(private http: HttpClient) {}

	getParameters(): Observable<ParametersResult> {
		return this.http.get<ParametersResult>(this.baseUrl);
	}

	getParametersCustom(): Observable<ParameterCustom[]> {
		return this.http.get<ParameterCustom[]>(this.baseUrl + '/custom');
	}

    getDefaultFilePattern(): Observable<string> {
        return this.http.get<string>(`${this.baseUrl}/default-file-pattern`)
    }

	updateParameter(param: Parameter): Observable<Parameter> {
		return this.http.put<Parameter>(this.baseUrl, param);
	}

	updateParameterCustom(param: any): Observable<any> {
		return this.http.put<any>(this.baseUrl + '/custom', param);
	}

    getForClientConfiguration(): Observable<Parameter[]> {
        return this.http.get<Parameter[]>(`${this.baseUrl}/client-configuration`);
    }
}
